export const REVIEW_CHECKLIST_MODAL = 'checklistReview';
export const CREATE_ISSUE_MODAL = 'newIssueModal';
